<template>
    <div>
        <div class="card">
            <div class="card-header">
                <h5>Neraca</h5>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group row">
                            <label for="month" class="col-sm-3 col-form-label text-left">Date</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="year"/>
                            </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-primary" @click="refreshList">Search</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table table-item mb-0 table-sm table-striped table-hover">
                                <tr>
                                    <th style="width: 50%">Account</th>
                                    <th colspan="2">Januari</th>
                                    <th colspan="2">Februari</th>
                                    <th colspan="2">Maret</th>
                                    <th colspan="2">April</th>
                                    <th colspan="2">Mei</th>
                                    <th colspan="2">Juni</th>
                                    <th colspan="2">July</th>
                                    <th colspan="2">Agustus</th>
                                    <th colspan="2">September</th>
                                    <th colspan="2">Oktober</th>
                                    <th colspan="2">November</th>
                                    <th colspan="2">Desember</th>
                                </tr>

                                <tr>
                                    <th>#</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                    <th>Jumlah</th><th>Total</th>
                                </tr>
                                <tbody>
                                    <tr v-for="a in getFixAsset" :key="a.account_code">
                                        <td colspan="1" v-if="a.hierarcy==1" style="background-color: #453123; color: white;"><span><b>{{ a.account_code}} {{ a.account_name }} - {{ a.method }}</b></span></td>
                                        <td v-else-if="a.hierarcy==2"><span class="ml-3">{{ a.account_code}} {{ a.account_name }} - {{ a.method }}</span></td>
                                        <td v-else-if="a.hierarcy==3" ><span class="ml-5"><b>{{ a.account_name }}</b></span></td>
                                        <td v-for="p in a.perMonth" :key="p.id">
                                            <span v-if="a.hierarcy==2">{{ p.total}}</span>
                                            <span v-else-if="a.hierarcy==3"><b>{{ p.total}}</b></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer"></div>
        </div>
    </div>
</template>
<script>
import Axios from 'axios'
import { financeUrl, getHeader } from '../../config'
export default {
  name: 'NeracaLajur',
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      contact: null,
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: 0,
      saldoAkhir: null,
      account: [{
        id: null,
        hierarcy: null,
        account_code: null,
        account_name: null,
        method: null,
        total: null,
        perMonth: [{
          id: null,
          month: null,
          total: null
        }]
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  mounted () {
    this.refreshList()
  },
  methods: {
    editJournal: function (id) {
      alert(id)
    },
    refreshList: function () {
      var url = financeUrl + '/neraca?year=' + this.year
      console.log(url)
      Axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.account = response.data.data
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  },
  computed: {
    getFixAsset: function () {
      return this.account.filter(d => d.method === 'fixasset')
    },
    getEquity: function () {
      return this.account.filter(d => d.method === 'equity')
    }
  }
}
</script>
